// (function () {

//   /* ── CSS inject ── */
//   var style = document.createElement('style');
//   style.innerHTML = [
//     '[data-fade] {',
//     '  opacity: 0;',
//     '  transform: translateY(32px);',
//     '  transition: opacity 0.85s cubic-bezier(0.22, 1, 0.36, 1), transform 0.85s cubic-bezier(0.22, 1, 0.36, 1);',
//     '}',
//     '[data-fade].is-visible {',
//     '  opacity: 1;',
//     '  transform: translateY(0);',
//     '}',
//   ].join('\n');
//   document.head.appendChild(style);

//   /* ── Stagger delay for siblings ── */
//   function applyStagger(entries) {
//     var groups = {};

//     entries.forEach(function (entry) {
//       if (!entry.isIntersecting) return;
//       var el     = entry.target;
//       var parent = el.parentElement;
//       var key    = parent ? parent : 'root';

//       if (!groups[key]) groups[key] = [];
//       groups[key].push(el);
//     });

//     Object.keys(groups).forEach(function (key) {
//       groups[key].forEach(function (el, i) {
//         setTimeout(function () {
//           el.classList.add('is-visible');
//           observer.unobserve(el);
//         }, i * 160);
//       });
//     });
//   }

//   /* ── Observer ── */
//   var observer = new IntersectionObserver(function (entries) {
//     applyStagger(entries);
//   }, {
//     threshold: 0.1,
//     rootMargin: '0px 0px -60px 0px'
//   });

//   /* ── Observe all current [data-fade] elements ── */
//   function observeAll() {
//     document.querySelectorAll('[data-fade]:not(.is-visible)').forEach(function (el) {
//       observer.observe(el);
//     });
//   }

//   /* ── Init ── */
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', observeAll);
//   } else {
//     observeAll();
//   }

//   /* ── Shopify editor support ── */
//   document.addEventListener('shopify:section:load', function () {
//     setTimeout(observeAll, 550);
//   });

// })();


(function () {

  /* ── CSS inject ── */
  var style = document.createElement('style');
  style.innerHTML = [
    '[data-fade] {',
    '  opacity: 0;',
    '  transform: translateY(56px);',
    '  transition: opacity 1.3s cubic-bezier(0.16, 1, 0.3, 1), transform 1.3s cubic-bezier(0.16, 1, 0.3, 1);',
    '}',
    '[data-fade].is-visible {',
    '  opacity: 1;',
    '  transform: translateY(0);',
    '}',
  ].join('\n');
  document.head.appendChild(style);

  /* ── Stagger delay for siblings ── */
  function applyStagger(entries) {
    var groups = {};

    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el     = entry.target;
      var parent = el.parentElement;
      var key    = parent ? parent : 'root';

      if (!groups[key]) groups[key] = [];
      groups[key].push(el);
    });

    Object.keys(groups).forEach(function (key) {
      groups[key].forEach(function (el, i) {
        setTimeout(function () {
          el.classList.add('is-visible');
          observer.unobserve(el);
        }, 220 + i * 200);
      });
    });
  }

  /* ── Observer ── */
  var observer = new IntersectionObserver(function (entries) {
    applyStagger(entries);
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -60px 0px'
  });

  /* ── Observe all current [data-fade] elements ── */
  function observeAll() {
    document.querySelectorAll('[data-fade]:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Init ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  /* ── Shopify editor support ── */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(observeAll, 550);
  });

})();